import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_MATCH } from "../../utils/api/ApiConstant";
import { DataTable, Filter, SubHeading, Switch } from "../../shared/Components";
import { postAxios } from "../../shared/Services/commonService";
import showToast from "../../utils/toastUtil";
import DateUtils from "../../utils/dateUtils";
import { createImportColumn } from "../../utils/importColumn";

const ImportStep3 = () => {
  const location = useLocation();
  const rowData = location.state;
  const navigate = useNavigate();
  const { id, source, sportName, tournamentName, sportId } = useParams();
  const [selectedItems, setSelectedItems] = useState({});

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importMatchData", source, id],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_MATCH}/${source}`, {
        competition_id: id,
      }),
  });

  const handleSwitchToggle = (id) => {
    setSelectedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(`${IMPORT_MATCH}/${source}`, {
        event_ids: selectedIds,
        competition_id: id,
      });

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Name",
        cell: ({ getValue, row }) => {
          return (
            <span
              onClick={() =>
                navigate(
                  `/config/import4/${source}/${sportId}/${id}/${row?.original?.Id}/${sportName}/${tournamentName}/${row?.original?.Name}`,
                  {
                    state: {
                      ...rowData,
                      match: row?.original,
                      source: source,
                      sportId: sportId,
                      tournamentId: id,
                    },
                  },
                )
              }
              className="cursor-pointer btn btn_default"
            >
              {getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "OpenOn",
        header: "Open On",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
      },
      {
        accessorKey: "actionOn",
        header: "Action Date",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
      },
      createImportColumn({
        data,
        selectedItems,
        setSelectedItems,
        handleSwitchToggle,
      }),
    ],
    [data, selectedItems],
  );
  return (
    <>
      <SubHeading
        eyebrow="Configuration"
        breadcrumbs={[
          {
            label: "Import",
          },
          {
            label: `Sport (${sportName})`,
            path: "/configuration/import",
          },
          {
            label: `Tournament (${tournamentName})`,
            path: `/config/import2/${source}/${sportId}/${sportName}`,
          },
          {
            label: "Matches",
          },
        ]}
        isAddBtnPage={false}
        isAddBtn={false}
        isBack={true}
        isImport={true}
        onClick={handleImport}
      />
      <Filter
        isEvent={true}
        isEventDisabled={true}
        buttonVisible={false}
        selectedSource={source}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default ImportStep3;
